import { api, baseAuth } from "apiConnections";
import { AxiosRequestConfig } from "axios";

const requests = {
    logout: (data: object, config: AxiosRequestConfig) =>
        baseAuth.post(`/gp/sso/logout`, data, config),
    me: (config: AxiosRequestConfig) => api.get(`/user/me`, config),
    permissions: (config: AxiosRequestConfig) =>
        api.get(`/user/permissions`, config),
};

export default requests;
